export default "__VITE_ASSET__DAJfJcQg__"